














import Vue from "vue";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";

const scrollTop = function(
	el: HTMLElement,
	from: number = 0,
	to: number,
	duration: number = 500,
	endCallback?: any
) {
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame =
			(window as any).webkitRequestAnimationFrame ||
			(window as any).mozRequestAnimationFrame ||
			(window as any).msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}
	const difference = Math.abs(from - to);
	const step = Math.ceil((difference / duration) * 50);

	function scroll(start: number, end: number, step: number) {
		if (start === end) {
			endCallback && endCallback();
			return;
		}

		let d = start + step > end ? end : start + step;
		if (start > end) {
			d = start - step < end ? end : start - step;
		}

		if (el === (window as any)) {
			window.scrollTo(
				window.scrollX || document.documentElement.scrollLeft,
				d
			);
		} else {
			el.scrollTop = d;
		}
		window.requestAnimationFrame(() => scroll(d, end, step));
	}
	scroll(from, to, step);
};

const on = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event && handler) {
			element.addEventListener(event, handler, false);
		}
	};
})();

const off = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event) {
			element.removeEventListener(event, handler, false);
		}
	};
})();

@Component
export default class ElBackTop extends Vue {
	@Prop({ type: Number, default: 400 }) height!: number;
	@Prop({ type: Number, default: 30 }) bottom!: number;
	@Prop({ type: Number, default: 30 }) right!: number;
	@Prop({ type: Number, default: 1000 }) duration!: number;

	backTop: boolean = false;

	mounted() {
		on(window, "scroll", this.handleScroll);
		on(window, "resize", this.handleScroll);
		this.$nextTick(() => {
			this.handleScroll();
		});
	}
	beforeDestroy() {
		off(window, "scroll", this.handleScroll);
		off(window, "resize", this.handleScroll);
	}

	get classes() {
		return [
			`back-top-page`,
			{
				[`show`]: this.backTop
			}
		];
	}
	get styles() {
		return {
			bottom: `${this.bottom}px`,
			right: `${this.right}px`
		};
	}
	get innerClasses() {
		return `back-top-inner`;
	}
	handleScroll() {
		this.backTop = window.pageYOffset >= this.height;
	}
	back() {
		const sTop =
			document.documentElement.scrollTop || document.body.scrollTop;
		scrollTop(window as any, sTop, 0, this.duration);
		this.$emit("on-click");
	}
}
